// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";

import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, getAdditionalUserInfo, signInWithPopup, signOut, connectAuthEmulator,
           EmailAuthProvider, GoogleAuthProvider, OAuthProvider,
           signInWithEmailAndPassword, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { doc, setDoc, updateDoc, getDoc, getDocs, collection, query, where, addDoc, getFirestore, connectFirestoreEmulator, onSnapshot } from "firebase/firestore";
import { getStorage, ref, getDownloadURL, uploadBytes, connectStorageEmulator } from "firebase/storage";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';

//AI Integration
//import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";
//import { GoogleGenerativeAI } from "@google/generative-ai";

import './intrivity-admin-clients.js';
import { INTRIVITY_CLIENTS_UPDATED } from './intrivity-admin-clients.js';

import '@material/mwc-button';
import '@material/mwc-formfield';
import '@material/mwc-checkbox';
import '@material/mwc-textfield';
import '@material/mwc-textarea';
import '@material/mwc-select';
import '@material/mwc-list/mwc-list-item';

import { 
    emitEvent, loadJSONFromStorage, getJSONFromStorage, getScore, hasRole,
    INTRIVITY_LOAD_RESOURCES, INTRIVITY_LOAD_CLIENTS, INTRIVITY_LOAD_GROUPS,
    INTRIVITY_LOAD_TRAINER, INTRIVITY_LOAD_PROGRAM_MANAGER, INTRIVITY_LOAD_CLIENT_MANAGER,
    INTRIVITY_GROUP_REPORTS_LOADED, INTRIVITY_GOOGLE_LOGGED_IN, 
    INTRIVITY_GOOGLE_LOGGED_OUT, INTRIVITY_LOGIN, INTRIVITY_LOGGED_IN,
    INTRIVITY_LOGOUT, INTRIVITY_NAV_SELECT, INTRIVITY_PRINTABLE_TOGGLE,
    INTRIVITY_GROUP_SELECT, INTRIVITY_MASQUERADE, INTRIVITY_LOAD_GROUP_FROM_STORAGE,
    INTRIVITY_LOADED_GROUP, INTRIVITY_AI_SUMMARY, INTRIVITY_LOGIN_ERROR, INTRIVITY_LOCALE_CHANGED,
    buildCombinedReport, buildCombinedGroupReport
} from './utility.js'
import { a11yStyles, announce } from './a11y.js';
import { t, Localized, setLocale, getLocale, detectLocale, localeFromUrl, enabledLocales } from './i18n.js';
import { DOMAIN_NAMES, applyDomainOverlay, fetchDomainOverlay } from './domains.js';
import './login_dialog.js';
import './badge.js';
import './header_app.js';
import './nav_app.js';
import './name_banner_app.js';
import './profile_app.js';
import './user_app.js';
import './teams.js';
import './overview.js';
import './printable_app.js';
import './admin_config.js';

import './admin_users.js';
import './role_guide_app.js';
import './accessibility_app.js';
import './privacy_app.js';
import './admin_compliance.js';
import './admin_training_docs.js';
import './training_docs_app.js';
import './admin_audit_log.js';
import { recordAudit, AUDIT } from './audit_log.js';
import './ai_models_guide.js';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBPf-WUuhm7v-ixrQpuCuqg6xOG18ixLkk",
  authDomain: "my.intrivity.com",
  projectId: "intrivity-12c92",
  storageBucket: "intrivity-12c92.appspot.com",
  messagingSenderId: "931317535189",
  appId: "1:931317535189:web:8dfa9bb85f34f2828a6d5c",                   
  measurementId: "G-BEK1VQRZX6"                                         // optional
};
const app = initializeApp(firebaseConfig);  

//AI Integration
//const ai = getAI(app, { backend: new GoogleAIBackend() });
//const model = getGenerativeModel(ai, { model: "gemini-2.5-flash" });
//const ai = new GoogleGenerativeAI(firebaseConfig.apiKey);
//const model = ai.getGenerativeModel({
//  model: "gemini-2.5-flash"
//});

const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

// STATIC VARIABLES
export let user;                                                        // Universal user value
// Names typed into the email sign-up form, for the profile getUserProfile() creates.
let pendingSignupName;
export let defaultGroup;                                                // Universal default group for user
export const storage = getStorage();                                    // Firebase storage
export const functions = getFunctions(app);                             // Firebase functions
export const auth = getAuth(app);                                       // Firebase auth
export const db = getFirestore(app);                                    // Firestore database

if (['localhost', '127.0.0.1', 'localhost.fuqua.duke.edu'].includes(window.location.hostname)) {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    console.log('Firebase emulators connected');
}

// Firebase authentication state change handler
onAuthStateChanged(auth, (guser) => {
    if (guser) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        console.log("AuthStageChange: Google Signed In Emit Event");
        //console.log(guser);
        user = guser;
        console.log(user);
        emitEvent(INTRIVITY_GOOGLE_LOGGED_IN,{},document);
    } else {
        // User is signed out
        user = undefined;
        emitEvent(INTRIVITY_GOOGLE_LOGGED_OUT,{},document);
        console.log("AuthStageChange: Google Signed Out Emit Event");
    }
});


export class IntrivityApp extends Localized(LitElement) {

    static get properties() {
        return {
            user_profile: { type: Object },         // current user data
            masqueraded_user: { type: String },     // the user currently masqueraded
            selection: { type: String },            // page selected
            report: { type: Object },               // user mrts
            group_report: { type: Object },         // group mrts
            group_reports: { type: Array },         // user groups
            printable: { type: Boolean },           // printable view
            group_code: { type: String },           // the group code for user
            space_domain: { type: Object },         // report data
            message_domain: { type: Object },       // report data
            relationship_domain: { type: Object },  // report data
            time_domain: { type: Object },          // report data
            // The English domain files as stored; the *_domain properties above
            // are these with the reader's translation applied (see domains.js).
            message_domain_base: { type: Object },
            relationship_domain_base: { type: Object },
            time_domain_base: { type: Object },
            space_domain_base: { type: Object },
            
            current_selection: { type: String },

            base: {type: String},

            sample: { type: String },

            post: { type: String },
            callback: { type: String },
            surveymonkey: { type: String },
            payment: { type: String },
            _surveyProcessing: { type: Boolean },
            clients: { type: Array },
            groups: { type: Array },
            
            trainer_groups: { type: Array },
            pm_groups: { type: Array }
        };
    }

    constructor() {
        super();
        this.selection = "overview";
        // A direct link to /accessibility opens the statement for anyone,
        // signed in or not.
        if (typeof window !== 'undefined' && window.location.pathname === '/accessibility') {
            this.selection = "accessibility";
        }
        if (typeof window !== 'undefined' && window.location.pathname === '/privacy') {
            this.selection = "privacy";
        }
        this.base = "";
        this.post = "no";
        this.callback = "no";
        this.role = "Student";
        this.printable = false;
        
        // set context of methods in case of multiple instances
        this.getUserProfile = this.getUserProfile.bind(this);
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.loggedout = this.loggedout.bind(this);
        this.loadGroupFromStorage = this.loadGroupFromStorage.bind(this);
        this.loadGroups = this.loadGroups.bind(this);
        this.getUserGroup = this.getUserGroup.bind(this);
        this.handleSelection = this.handleSelection.bind(this);  
        this.groupSelected = this.groupSelected.bind(this);
        this.loadClients = this.loadClients.bind(this);
        this.loadTrainer = this.loadTrainer.bind(this);
        this.loadProgramManager = this.loadProgramManager.bind(this);
        this.loadClientManager = this.loadClientManager.bind(this);
        this.loadClientGroups = this.loadClientGroups.bind(this);
        this.masquerade = this.masquerade.bind(this);
        this.set_masquerade = this.set_masquerade.bind(this);
        this.quit_masquerade = this.quit_masquerade.bind(this);
        this.togglePrintable = this.togglePrintable.bind(this);
        this.runGAI = this.runGAI.bind(this);
        this.callbackRedirect = this.callbackRedirect.bind(this);
        this.requestedLoadGroup = this.requestedLoadGroup.bind(this);
        this.saveLocalePreference = this.saveLocalePreference.bind(this);
        this._localizeDomains = this._localizeDomains.bind(this);

        setLocale(detectLocale());
    }
       
    async tryLoadDomain(key, path) {
        try {
            console.log(`Loading ${key} from ${path}`);
            await getJSONFromStorage(this, key, path, this.masqueraded_user);
            console.log(`${key} loaded`, this[key]);
        } catch (err) {
            console.error(`Failed to load ${key}:`, err);
        }
    }

    firstUpdated() {

        if (this.callback === 'yes') {
            if (this.surveymonkey === 'yes') {
            //    this.user_profile.processing = true;
            //    localStorage.setItem("surveymonkey","yes");
            }
            this.callbackRedirect();
        } else {
            let val = localStorage.getItem("masqueraded_user");
            if (val) {
                this.set_masquerade(val);
            }
            let surveymonkeystore = localStorage.getItem("surveymonkey");
            if (surveymonkeystore) {
                //this.surveymonkey = surveymonkeystore;
                //this.user_profile.processing = true;
            }

            for (const name of Object.values(DOMAIN_NAMES)) {
                this.tryLoadDomain(`${name}_domain_base`, `domains/domain_${name}.json`);
            }
         
        }        

    }

    // Recomputes the displayed domains from the English files whenever either
    // those files or the language change. A later call supersedes an earlier
    // one still waiting on an overlay, so a quick language switch can't leave
    // the page in the previous language.
    async _localizeDomains() {
        const run = (this._localizeRun || 0) + 1;
        this._localizeRun = run;
        const locale = getLocale();
        await Promise.all(Object.values(DOMAIN_NAMES).map(async (name) => {
            const base = this[`${name}_domain_base`];
            if (!base) return;
            const overlay = await fetchDomainOverlay(name, locale);
            if (this._localizeRun === run) this[`${name}_domain`] = applyDomainOverlay(base, overlay);
        }));
    }

    updated(changedProps) {
        if (Object.values(DOMAIN_NAMES).some((name) => changedProps.has(`${name}_domain_base`))) {
            this._localizeDomains();
        }
        // Moving keyboard focus to <main> after a nav change means the next Tab
        // continues from the new content instead of restarting at the top of
        // the page (WCAG 2.4.3).
        if (changedProps.has('selection') && changedProps.get('selection') !== undefined) {
            const main = this.shadowRoot && this.shadowRoot.getElementById('main-content');
            if (main) main.focus();
        }

        if (changedProps.has('user_profile')) {
            if (this.user_profile && Array.isArray(this.user_profile.groups) && this.user_profile.groups.length > 0) {
            // non-blocking call; catch errors to avoid unhandled rejections
            this.loadGroups().catch(err => {
                console.error('loadGroups failed:', err);
            });
            } else {
            // clear previous group data if there are no groups now
            this.group_reports = [];
            }
        }
    }

    
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener(INTRIVITY_GOOGLE_LOGGED_IN, this.getUserProfile); // user logs in with google
        document.addEventListener(INTRIVITY_LOGIN, this.login);                     // log user in
        document.addEventListener(INTRIVITY_LOGGED_IN, this.getUserProfile);        // user logd in?
        document.addEventListener(INTRIVITY_GOOGLE_LOGGED_OUT, this.loggedout);     // user logs out with google 
        document.addEventListener(INTRIVITY_LOGOUT, this.logout);
        document.addEventListener(INTRIVITY_NAV_SELECT, this.handleSelection);      // page selection
        document.addEventListener(INTRIVITY_GROUP_SELECT, this.groupSelected);      // comparison group selected
        document.addEventListener(INTRIVITY_LOAD_CLIENTS, this.loadClients);        // load client data
        document.addEventListener(INTRIVITY_LOAD_PROGRAM_MANAGER, this.loadProgramManager);  // load pm data
        document.addEventListener(INTRIVITY_LOAD_CLIENT_MANAGER, this.loadClientManager);  // load client manager data
        document.addEventListener(INTRIVITY_LOAD_TRAINER, this.loadTrainer);        // load trainer dependencies
        document.addEventListener(INTRIVITY_MASQUERADE, this.masquerade);           // masquerade
        document.addEventListener(INTRIVITY_LOAD_GROUP_FROM_STORAGE, this.requestedLoadGroup); 
        document.addEventListener(INTRIVITY_PRINTABLE_TOGGLE, this.togglePrintable);
        document.addEventListener(INTRIVITY_AI_SUMMARY, this.runGAI);               // generate AI Summary
        this.addEventListener(INTRIVITY_CLIENTS_UPDATED, this.loadClients);
        window.addEventListener("resize", (e)=> { this.requestUpdate(); });        
        window.addEventListener(INTRIVITY_LOCALE_CHANGED, this.saveLocalePreference);
        window.addEventListener(INTRIVITY_LOCALE_CHANGED, this._localizeDomains);
    }

    disconnectedCallback() {
        document.removeEventListener(INTRIVITY_GOOGLE_LOGGED_IN, this.getUserProfile);
        document.removeEventListener(INTRIVITY_GOOGLE_LOGGED_OUT, this.loggedout);
        document.removeEventListener(INTRIVITY_LOGIN, this.login);
        document.removeEventListener(INTRIVITY_LOGGED_IN, this.getUserProfile);
        document.removeEventListener(INTRIVITY_LOGOUT, this.logout);
        document.removeEventListener(INTRIVITY_NAV_SELECT, this.handleSelection);
        document.removeEventListener(INTRIVITY_GROUP_SELECT, this.groupSelected);
        document.removeEventListener(INTRIVITY_LOAD_CLIENTS, this.loadClients);
        document.removeEventListener(INTRIVITY_LOAD_PROGRAM_MANAGER, this.loadProgramManager);  // load pm data
        document.removeEventListener(INTRIVITY_LOAD_CLIENT_MANAGER, this.loadClientManager);  // load client manager data
        document.removeEventListener(INTRIVITY_LOAD_TRAINER, this.loadTrainer);
        document.removeEventListener(INTRIVITY_MASQUERADE, this.masquerade);
        document.removeEventListener(INTRIVITY_PRINTABLE_TOGGLE, this.togglePrintable);
        document.removeEventListener(INTRIVITY_AI_SUMMARY, this.runGAI);               
        document.removeEventListener(INTRIVITY_LOAD_GROUP_FROM_STORAGE, this.requestedLoadGroup); 
        this.removeEventListener(INTRIVITY_CLIENTS_UPDATED, this.loadClients);
        window.removeEventListener("resize", (e)=> { this.requestUpdate(); });    
        window.removeEventListener(INTRIVITY_LOCALE_CHANGED, this.saveLocalePreference);
        window.removeEventListener(INTRIVITY_LOCALE_CHANGED, this._localizeDomains);
        super.disconnectedCallback();
    }

    // Handles all sign-in methods (Google/Microsoft popups, email/password
    // sign-in or sign-up). e.detail.provider selects the method; defaults to
    // 'google' so existing call sites that emit INTRIVITY_LOGIN with no
    // detail keep working unchanged. Success is picked up generically by the
    // module-level onAuthStateChanged listener (fires INTRIVITY_GOOGLE_LOGGED_IN
    // for any provider, which triggers getUserProfile) — failure is reported
    // via INTRIVITY_LOGIN_ERROR so a login UI can surface it.
    async login(e) {
        const detail = (e && e.detail) || {};
        const providerName = detail.provider || 'google';

        try {
            let result;
            if (providerName === 'microsoft') {
                result = await signInWithPopup(auth, microsoftProvider);
            } else if (providerName === 'email') {
                if (detail.mode === 'signup') {
                    // Creating the account fires onAuthStateChanged, whose
                    // getUserProfile() may write the new profile before
                    // updateProfile() lands -- so it reads the names from
                    // here, and they are also written below in case it won.
                    const firstName = detail.firstName || '';
                    const lastName = detail.lastName || '';
                    const displayName = [firstName, lastName].filter(Boolean).join(' ');
                    pendingSignupName = {email: detail.email.toLowerCase(), firstName, lastName, displayName};
                    result = await createUserWithEmailAndPassword(auth, detail.email, detail.password);
                    if (displayName) {
                        await updateProfile(result.user, {displayName});
                        await setDoc(doc(db, "users", result.user.email),
                            {email: result.user.email, firstName, lastName, displayName, fullName: displayName}, {merge: true});
                    }
                } else {
                    result = await signInWithEmailAndPassword(auth, detail.email, detail.password);
                }
            } else {
                result = await signInWithPopup(auth, googleProvider);
            }

            user = result.user;
            if (providerName === 'google') {
                user.credential = GoogleAuthProvider.credentialFromResult(result);
            } else if (providerName === 'microsoft') {
                user.credential = OAuthProvider.credentialFromResult(result);
            }
            if (user.credential) {
                user.token = user.credential.accessToken;
            }
            user.additional = getAdditionalUserInfo(result);
            this.getUserProfile();
        } catch (error) {
            console.log("User failed to login.", error);
            pendingSignupName = undefined;
            emitEvent(INTRIVITY_LOGIN_ERROR, {message: this._friendlyAuthError(error)}, this);
        }
    }

    _friendlyAuthError(error) {
        const messages = {
            'auth/email-already-in-use': 'auth.emailInUse',
            'auth/weak-password': 'auth.weakPassword',
            'auth/invalid-credential': 'auth.incorrectCredentials',
            'auth/invalid-email': 'auth.invalidEmail',
            'auth/user-not-found': 'auth.userNotFound',
            'auth/wrong-password': 'auth.incorrectCredentials',
            'auth/popup-closed-by-user': 'auth.cancelled',
            'auth/operation-not-allowed': 'auth.methodDisabled',
        };
        if (error && messages[error.code]) return t(messages[error.code]);
        return (error && error.message) || t('common.genericError');
    }

    logout() {
        console.log("logout called");
        signOut(auth).then(() => {
            this.loggedout();
        }).catch((error) => {
            if (this.callback === 'yes') {
                location.href = "https://my.intrivity.com";
            }
        }); 
    }
    
    loggedout() {
        user = undefined;
        pendingSignupName = undefined;
        this.user_profile = undefined;
        this.report = undefined;
        this.group_report = undefined;
        this.group_reports = undefined;
        this.masqueraded_user = undefined;
        
        // remove user report/group report
        localStorage.removeItem("report");
        localStorage.removeItem("group_report");
        localStorage.removeItem("masqueraded_user");
        
        // remove other reports
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && key.startsWith("reports_")) {
              localStorage.removeItem(key);
            }
        }
        
        // remove domain info
        //localStorage.removeItem("message_domain");
        //localStorage.removeItem("space_domain");
        //localStorage.removeItem("time_domain");
        //localStorage.removeItem("relationship_domain");
        
        this.selection = "overview";
        // A direct link to /accessibility opens the statement for anyone,
        // signed in or not.
        if (typeof window !== 'undefined' && window.location.pathname === '/accessibility') {
            this.selection = "accessibility";
        }
        if (typeof window !== 'undefined' && window.location.pathname === '/privacy') {
            this.selection = "privacy";
        }
        this.requestUpdate(); 
        
        if (this.callback === 'yes') {
            location.href = "https://my.intrivity.com";
        }
    }
         
    // Store a language the person picked on their profile, so it follows them
    // to other devices. Only for their own profile, and only once it exists --
    // first sign-in creates the document elsewhere.
    async saveLocalePreference(e) {
        const { locale, userChosen } = (e && e.detail) || {};
        if (!userChosen || !user || !user.email || this.masqueraded_user) return;
        if (!this.user_profile || this.user_profile.language === locale) return;
        try {
            await updateDoc(doc(db, 'users', user.email), { language: locale });
            this.user_profile.language = locale;
        } catch (err) {
            console.error('Could not save language preference:', err);
        }
    }

    async getUserProfile() {
        if (user) {
            console.log("Getting the user's profile: " + (this.masqueraded_user ? this.masqueraded_user: user.email));
            const docRef = doc(db, "users", this.masqueraded_user ? this.masqueraded_user: user.email);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                this.user_profile = docSnap.data();
                // A profile can exist without an email (sign-up writes the
                // names before this runs, so the new-profile branch below is
                // skipped). Everything keyed off user_profile.email needs it.
                if (!this.user_profile.email && !this.masqueraded_user) {
                    this.user_profile.email = user.email;
                    try {
                        await setDoc(docRef, {email: user.email}, { merge: true });
                    } catch (err) {
                        console.log("Error saving email to profile.", err);
                    }
                }
                // A saved language follows the person across devices, but a
                // masquerading admin keeps their own, and ?lang= wins over both.
                const language = this.user_profile.language;
                if (!this.masqueraded_user && !localeFromUrl() && enabledLocales().includes(language)) {
                    setLocale(language);
                }
                console.log("Found user's profile: ");
                console.log(this.user_profile);
                //if (this.user_profile.group)
                //    this.getUserGroup(this.user_profile.group);
            } else {
                
                // No user profile
                if (this.masqueraded_user) {
                    alert(t('app.masqueradeNotFound'));
                    this.masqueraded_user = undefined;
                    return;
                }
                
                this.user_profile = {};
               
                this.user_profile.email = user.email;
                this.user_profile.displayName = user.displayName;
                const signupName = pendingSignupName && pendingSignupName.email === (user.email || '').toLowerCase() ?
                    pendingSignupName : null;
                if (signupName && signupName.displayName) {
                    this.user_profile.displayName = signupName.displayName;
                }
                // Google's OAuth2 userinfo uses given_name/family_name;
                // Microsoft Graph uses givenName/surname.
                const additionalProfile = (user.additional && user.additional.profile) || {};
                if (signupName && signupName.firstName) {
                    this.user_profile.firstName = signupName.firstName;
                } else if (user.firstName) {
                    this.user_profile.firstName = user.firstName;
                } else if (additionalProfile.given_name || additionalProfile.givenName) {
                    this.user_profile.firstName = additionalProfile.given_name || additionalProfile.givenName;
                }
                if (signupName && signupName.lastName) {
                    this.user_profile.lastName = signupName.lastName;
                } else if (user.lastName) {
                    this.user_profile.lastName = user.lastName;
                } else if (additionalProfile.family_name || additionalProfile.surname) {
                    this.user_profile.lastName = additionalProfile.family_name || additionalProfile.surname;
                }
                this.user_profile.fullName = this.user_profile.displayName;
                
                if (user.photoURL) this.user_profile.image = user.photoURL;
                
                try {
                    await setDoc(doc(db, "users", user.email), this.user_profile, { merge: true });
                } catch (err) {
                    alert(t('app.profileSaveError'));
                    console.log("Error saving user data to firestore.");
                    console.log(err);
                }
                console.log("Created new user from " + user);
            }
            
            // Just got the user profile- push user to view user page
            this.selection = "user";
            // A direct link to /roles takes any authenticated user straight
            // to the Role Guide instead of the default dashboard.
            if (window.location.pathname === '/roles') {
                this.selection = "roles";
            }
            if (window.location.pathname === '/accessibility') {
                this.selection = "accessibility";
            }
            if (window.location.pathname === '/privacy') {
                this.selection = "privacy";
            }
            console.log("Getting report.. " + "reports/" +  (this.masqueraded_user ? this.masqueraded_user: user.email));
            getJSONFromStorage(this, "report", "reports/" +  (this.masqueraded_user ? this.masqueraded_user: user.email) + ".json", this.masqueraded_user);  
 
            // if there is a user report... and sureveymonkey is yes, remove surveymonkey
            if (this.report) {
                this.surveymonkey = 'no';
                localStorage.removeItem("surveymonkey");
                this.user_profile.processing = false;
            }

            //this.loadGroups();
            if (this.user_profile.group)
                    this.getUserGroup(this.user_profile.group);
            
            
        }  
                
        let group_hash = window.location.hash;
        if (group_hash && group_hash.length > 0) { 
            this.group_code = group_hash.substring(1);
            console.log(this.group_code);
        }
        
        this.requestUpdate();
    }
    
    // Wrap in an async function so you can use await
    async runGAI() {
       
      console.log("Starting AI Summary");
       
      const content = document.body.innerText || document.documentElement.innerText;
      //const content = document.querySelector("intrivity-printable").innerText;


      // optional: trim, remove repeated whitespace
      const cleaned = content.replace(/\s+/g, ' ').trim().slice(0, 500000); // guard size

      // Provide a prompt that contains text
      const prompt = `
        This is my Intrivity assessment.
        Please summarize the following document clearly and concisely:

        ${content}
      `;

      console.log("Starting AI Summary input");
      
      // To generate text output, call generateContent with the text input
      const result = await model.generateContent(prompt);
      

      console.log("Response AI Summary Generated"); 
      
      const response = result.response;
      const text = response.text();
      
      console.log("Got response");
      
      console.log(text);
      
    }
    
    async loadGroups() {
      try {
        console.log("Loading user groups...");
        const groups = [];

        if (!this.user_profile || !Array.isArray(this.user_profile.groups) || this.user_profile.groups.length === 0) {
          console.log("No groups to load for user_profile.");
          this.group_reports = [];
          this.requestUpdate();
          return;
        }

        // build loader promises
        const loaders = this.user_profile.groups.map(async (groupId) => {
          try {
            const storedVal = localStorage.getItem("reports_" + groupId);
            if (storedVal) {
              const group = JSON.parse(storedVal);
              if (group.stored) {
                const now = new Date();
                const storedDate = new Date(group.stored);
                const dayAgo = new Date(now);
                dayAgo.setDate(now.getDate() - 1);
                if (dayAgo > storedDate) {
                  // stale: re-fetch remote but use failover cached if remote fails
                  return await this.loadGroupFromStorage(groups, groupId, group);
                } else {
                  groups.push(group);
                  return group;
                }
              } else {
                return await this.loadGroupFromStorage(groups, groupId, group);
              }
            } else {
              return await this.loadGroupFromStorage(groups, groupId);
            }
          } catch (e) {
            console.warn("Error in individual group loader for " + groupId, e);
            // don't throw — let loadGroupFromStorage handle failover
            return null;
          }
        });

        // Wait for all loaders to settle; do not let any single rejection abort the whole thing
        const results = await Promise.allSettled(loaders);

        // results may have populated the `groups` array already (loadGroupFromStorage pushes into it).
        // But in case some loaders returned direct group objects, append them.
        for (const r of results) {
          if (r.status === 'fulfilled' && r.value) {
            // avoid duplicates (loadGroupFromStorage already pushed some)
            if (!groups.includes(r.value)) groups.push(r.value);
          } else if (r.status === 'rejected') {
            console.warn('A group loader rejected:', r.reason);
          }
        }

        // filter out nulls
        this.group_reports = groups.filter(g => g);
        console.log((this.group_reports || []).length + " groups loaded.");
        this.requestUpdate();
        // optionally emit the loaded event
        // emitEvent(INTRIVITY_GROUP_REPORTS_LOADED, {}, document);
      } catch (err) {
        // top-level safeguard so nothing thrown here can break Lit
        console.error('loadGroups failed unexpectedly:', err);
        this.group_reports = this.group_reports || [];
        this.requestUpdate();
      }
    }

    async requestedLoadGroup(e) {
        let g = await this.loadGroupFromStorage(this.groups, e.detail.group_uuid, null, true);
        console.log(g);
        emitEvent(INTRIVITY_LOADED_GROUP, g, document);
    }
    
    async loadGroupFromStorage(groups, groupId, failover, nocache) {
      try {
        const storageRef = ref(storage, `reports/groups/${groupId}.json`);
        // Return the promise chain; ensure any error is caught below
        const url = await getDownloadURL(storageRef).catch(err => {
          console.warn(`getDownloadURL failed for ${groupId}:`, err);
          return null;
        });

        if (!url) {
          if (failover) {
            groups.push(failover);
            return failover;
          }
          // push an empty placeholder or just return null
          console.warn(`No URL for group ${groupId} and no failover.`);
          return null;
        }

        // fetch JSON and parse safely
        const response = await fetch(url).catch(err => {
          console.warn(`fetch failed for ${groupId}:`, err);
          return null;
        });
        if (!response || !response.ok) {
          console.warn(`Bad response for ${groupId}:`, response && response.status);
          if (failover) {
            if (!nocache) groups.push(failover);
            return failover;
          }
          return null;
        }

        const data = await response.json().catch(err => {
          console.warn(`JSON parse failed for ${groupId}:`, err);
          return null;
        });

        if (data) {
          if (!nocache) { 
            groups.push(data);
            const store_this = cloneDeep(data);
            store_this.stored = new Date().toISOString();
            try {
              localStorage.setItem(`reports_${groupId}`, JSON.stringify(store_this));
            } catch (e) {
              console.warn('Could not store group in localStorage:', e);
            }
          }
          return data;
        } else {
          if (failover) {
            if (!nocache) groups.push(failover);
            return failover;
          }
          return null;
        }
      } catch (err) {
        console.error('Unexpected error in loadGroupFromStorage:', err);
        if (failover) {
          if (!nocache) groups.push(failover);
          return failover;
        }
        return null;
      }
    }


    
    async getUserGroup(gr) {
        //const docRef = doc(db, "groups", gr);
        //const docSnap = await getDoc(docRef);

        //if (docSnap.exists()) {
        //    defaultGroup = docSnap.data();
            getJSONFromStorage(this, "group_report", "reports/groups/" + gr + ".json", this.masqueraded_user);  
        //} 
        this.requestUpdate();       
    }
    
    handleSelection(e) {
        if (e.detail.selection !== this.selection) {
            this.selection = e.detail.selection;
            window.scrollTo(0, 0);
            this.requestUpdate();
        }
    }
    
    groupSelected(e) {
        this.group_report = e.detail;
        this.requestUpdate();
    }
    
    async loadClients() {
        console.log("loading clients");
        const snapshot = await getDocs(collection(db, "clients"));
        this.clients = snapshot.docs.map(doc => doc.data());
        console.log(this.clients);
        this.requestUpdate();
    }    
    
    // loadProgramManager and loadClientManager can both fire from the same nav
    // click and each resolves independently, so merge into pm_groups (dedup by
    // uuid) instead of overwriting it, or whichever resolves last wins.
    _mergeIntoPmGroups(groups) {
        const existing = this.pm_groups || [];
        const merged = new Map(existing.map(g => [g.uuid, g]));
        groups.forEach(g => { if (g) merged.set(g.uuid, g); });
        this.pm_groups = Array.from(merged.values());
        this.requestUpdate();
    }

    async loadProgramManager() {
        console.log("loading program manager " + this.user_profile.email);
        const qpm = query(
          collection(db, "group_roles"),
          where("email", "==", this.user_profile.email),
          where("role", "array-contains", "program_manager")
        );
        const groupPMIds = (await getDocs(qpm)).docs.map(d => d.data().group_uuid);
        const pmGroupSnap = await Promise.all(
            groupPMIds.map(async id => await getDoc(doc(db, "groups", id)))
        );
        const pmGroups = pmGroupSnap.map(doc => doc.data());
        this._mergeIntoPmGroups(pmGroups);
    }

    async loadClientManager() {
        console.log("loading client manager " + this.user_profile.email);
        const qcm = query(
          collection(db, "client_roles"),
          where("email", "==", this.user_profile.email),
          where("role", "array-contains", "client_manager")
        );
        const clientIds = [...new Set((await getDocs(qcm)).docs.map(d => d.data().client_uuid))];
        if (clientIds.length === 0) {
            this.pm_groups = this.pm_groups || [];
            this.requestUpdate();
            return;
        }
        // Firestore 'in' supports up to 30 values; every group/team doc carries
        // a denormalized clientid, so this single query returns the full cascade
        // (top groups + their teams) for every client this user manages.
        const qGroups = query(
          collection(db, "groups"),
          where("clientid", "in", clientIds.slice(0, 30))
        );
        const cmGroups = (await getDocs(qGroups)).docs.map(d => d.data());
        this._mergeIntoPmGroups(cmGroups);
    }
    
    async loadTrainer() {
        console.log("loading trainer " + this.user_profile.email);
        // we need to get the groups for the trainer
        const qt = query(
          collection(db, "group_roles"),
          where("email", "==", this.user_profile.email),
          where("role", "array-contains", "trainer")
        );
        const groupTIds = (await getDocs(qt)).docs.map(d => d.data().group_uuid);
        console.log(groupTIds);
        const trainerGroupSnap = await Promise.all(
            groupTIds.map(async id => await getDoc(doc(db, "groups", id)))
        );
        const trainerGroups = trainerGroupSnap.map(doc => doc.data());
        console.log(trainerGroups);
        this.trainer_groups = trainerGroups;
        this.requestUpdate();
    } 
    
    async loadClientGroups(clientId) {
        console.log(`Loading groups for client ID: ${clientId}`);
        const groupsRef = collection(db, "groups");
        const qcl = query(groupsRef, where("clientid", "==", clientId));

        try {
            const snapshot = await getDocs(qcl);
            const _groups = snapshot.docs.map(doc => doc.data());
            console.log(_groups);
            this.groups = _groups;
        } catch (error) {
            console.error("Error loading groups for " + clientId + ":", error);
            return [];
        }
    }    

    masquerade(e) {
        // Logged here rather than in set_masquerade: that runs again on every
        // page load to restore the session from localStorage, and would record
        // a fresh "started" entry each time.
        recordAudit(AUDIT.MASQUERADE_START, { subject: e.detail.email });
        this.set_masquerade(e.detail.email); 
        window.open(
            window.location.href,
            '_blank',
            'width=800,height=600'
        );
        //window.location.reload(true);
    }
    set_masquerade(email) {
        console.log("Masqueradeing as: " + email);
        this.masqueraded_user = email;
        localStorage.setItem("masquerader", JSON.stringify(this.user_profile));
        localStorage.setItem("masqueraded_user", email);
        localStorage.removeItem('report');    
        localStorage.removeItem('group_report');
       // this.getUserProfile();        
    }

    quit_masquerade(e) {
        if (this.masqueraded_user) {
            // recordAudit reads the actor from the auth token, which still names
            // the real administrator -- masquerading changes app state, not the
            // authenticated identity.
            recordAudit(AUDIT.MASQUERADE_END, { subject: this.masqueraded_user });
        }
        this.masqueraded_user = undefined;
        this.trainer_groups = undefined;
        this.pm_groups = undefined;
        localStorage.removeItem('masqueraded_user');
        localStorage.removeItem('masquerader');
        localStorage.removeItem('report');    
        localStorage.removeItem('group_report');
        this.getUserProfile();
    }
    
    togglePrintable(e) {
        const turningOn = !this.printable;
        this.printable = turningOn;
        if (turningOn) {
            // 'afterprint' fires once the print dialog is dismissed, whether
            // the user printed or cancelled, so we can drop back out of the
            // printable view automatically instead of leaving them stuck on it.
            this._afterPrintHandler = () => {
                window.removeEventListener('afterprint', this._afterPrintHandler);
                this._afterPrintHandler = null;
                this.printable = false;
            };
            window.addEventListener('afterprint', this._afterPrintHandler);

            // Wait for the printable report to finish rendering before
            // handing the user straight to the browser's print dialog.
            this.updateComplete.then(() => {
                requestAnimationFrame(() => window.print());
            });
        } else if (this._afterPrintHandler) {
            window.removeEventListener('afterprint', this._afterPrintHandler);
            this._afterPrintHandler = null;
        }
    }

    callbackRedirect() {
        console.log("SETTING THE CALLBACK - waiting for survey processing");

        let unsubscribeSnapshot = null;
        let processingStarted = false;

        const done = () => {
            if (unsubscribeSnapshot) { unsubscribeSnapshot(); unsubscribeSnapshot = null; }
            clearTimeout(notStartedTimer);
            clearTimeout(fallbackTimer);
            this.loggedout();
        };

        // If processing never starts within 30s the webhook already ran — redirect.
        const notStartedTimer = setTimeout(() => {
            if (!processingStarted) done();
        }, 30000);

        // Hard ceiling: redirect after 2 minutes no matter what.
        const fallbackTimer = setTimeout(done, 120000);

        const startListening = (email) => {
            unsubscribeSnapshot = onSnapshot(doc(db, 'users', email), (snap) => {
                if (!snap.exists()) return;
                const data = snap.data();
                if (data.processing === true) {
                    processingStarted = true;
                    this._surveyProcessing = true;
                }
                if (processingStarted && data.processing === false) {
                    done();
                }
            });
        };

        if (user?.email) {
            startListening(user.email);
        } else {
            const unsubAuth = onAuthStateChanged(auth, (authUser) => {
                if (authUser?.email) {
                    unsubAuth();
                    startListening(authUser.email);
                }
            });
        }
    }
    
    static get styles() {
      return [a11yStyles, css` 
        @media print { 
  
            /* Define the header and footer */ 
            @page { 
                margin: 0 !important; 
            } 
  
        } 

        /* WCAG 2.4.1 Bypass Blocks — visually hidden until focused, then
           anchored over the top-left of the banner. */
        .skip-link {
            position: absolute;
            left: -9999px;
            top: 0;
            z-index: 1000;
            background: #ffffff;
            color: #1a1a1a;
            padding: 12px 20px;
            font-size: 1rem;
            font-weight: 600;
            text-decoration: underline;
            border: 2px solid #1a1a1a;
        }
        .skip-link:focus {
            left: 0;
        }
        main:focus {
            outline: none;
        }
        /* Grid items default to min-width: auto (their content's min-content),
           so a domain page whose feedback text has a wide unbroken run can
           force this 4fr column past its share and squeeze the nav's 1fr
           column narrower than on every other page. Capping it at 0 lets
           the column wrap/overflow internally instead of stealing nav width. */
        main {
            min-width: 0;
        }
        @media print {
            .skip-link { display: none; }
        }
      `];
    }
      
    render() {
        return html`
            ${this.callback === 'yes' ? html`   
                <div style="display: grid; grid-template-columns: 1fr;">
                    <intrivity-header .printable=${this.printable} .user_profile=${this.user_profile} style="grid-column-start: 1; grid-column-end: ${window.innerWidth < 600 ? '2': '3'};"></intrivity-header>
                    ${this.payment === 'success' ? html`
                            <h3 role="status" style="font-size: larger; height: 300px; display: grid; align-items: center; margin: auto;">
                                ${t('app.paymentSuccess')}
                            </h3>              
                    `: html`
                        ${this.payment === 'fail' ? html`
                                <h3 role="alert" style="font-size: larger; height: 300px; display: grid; align-items: center; margin: auto;">${t('app.paymentFailed')}</h3>              
                        `: html`
                            ${this.payment === 'cancel' ? html`
                                    <h3 role="status" style="font-size: larger; height: 300px; display: grid; align-items: center; margin: auto;">${t('app.paymentCancelled')}</h3>              
                            `: html`
                                    <h3 role="status" aria-live="polite" style="font-size: larger; height: 300px; display: grid; align-items: center; justify-items: center; margin: auto; text-align: center;">
                                        ${this._surveyProcessing
                                            ? t('app.processingResults')
                                            : html`${t('app.surveySubmitted')}<br/>${t('app.preparingResults')}`}
                                        <div aria-hidden="true" style="margin-top: 1.5rem; width: 2.5rem; height: 2.5rem; border: 4px solid #ccc; border-top-color: #555; border-radius: 50%; animation: spin 0.9s linear infinite;"></div>
                                    </h3>
                                    <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
                            `}
                        `}
                    `}
                </div>        
            `: html`
                ${this.space_domain && this.message_domain && this.relationship_domain && this.time_domain ? html`
                    ${this.printable ? html`
                        <intrivity-printable .group_reports=${this.group_reports} .group_report=${this.group_report} .user_profile=${this.user_profile} .report=${this.report} .message_domain=${this.message_domain} .space_domain=${this.space_domain} .relationship_domain=${this.relationship_domain} .time_domain=${this.time_domain}></intrivity-printable>
                    `: html`

                        <a class="skip-link" href="#main-content" @click=${(e) => {
                            e.preventDefault();
                            const main = this.shadowRoot.getElementById('main-content');
                            if (main) { main.focus(); main.scrollIntoView(); }
                        }}>${t('app.skipToContent')}</a>

                        <div style="display: grid; grid-template-columns: ${window.innerWidth < 600 ? '1fr': '1fr 4fr'};">

                            <intrivity-header .printable=${this.printable} .user_profile=${this.user_profile} style="grid-column-start: 1; grid-column-end: ${window.innerWidth < 600 ? '2': '3'};"></intrivity-header>

                            <intrivity-nav .masqueraded_user=${this.masqueraded_user} .report=${this.report} .group_reports=${this.group_reports} .user_profile=${this.user_profile} .selection=${this.selection} .horizontal=${window.innerWidth < 600}></intrivity-nav>

                            <main id="main-content" tabindex="-1">

                                ${this.report && this.group_reports ? html`
                                    <intrivity-name-banner .group_report=${this.group_report} .group_reports=${this.group_reports} .user_profile=${this.user_profile} .report=${this.report} .message_domain=${this.message_domain} .relationship_domain=${this.relationship_domain} .time_domain=${this.time_domain} .space_domain=${this.space_domain} size="0.9" m="${getScore(this.report.m.average)}" r="${getScore(this.report.r.average)}" t="${getScore(this.report.t.average)}" s="${getScore(this.report.s.average)}"></intrivity-name-banner>
                                `: html`
                                    <intrivity-name-banner .user_profile=${this.user_profile} size="0.9"></intrivity-name-banner>
                                `}

                                ${this.selection === 'user' ? html`<intrivity-user .group_reports=${this.group_reports} .report=${this.report} .user_profile=${this.user_profile}></intrivity-user>`: html``}
                                ${this.selection === 'teams' ? html`<intrivity-teams .group_reports=${this.group_reports} .group_report=${this.group_report}></intrivity-teams>`: html``}
                                ${this.selection === 'profile' ? html`
                                    <intrivity-profile .group_report=${this.group_report} .report=${this.report} .user_profile=${this.user_profile} .message_domain=${this.message_domain} .space_domain=${this.space_domain} .relationship_domain=${this.relationship_domain} .time_domain=${this.time_domain}></intrivity-profile>
                                `: html``}
                                ${this.selection === 'overview' ? html`<intrivity-overview></intrivity-overview>`: html``}
                                ${this.selection === 'roles' ? html`<intrivity-role-guide></intrivity-role-guide>`: html``}
                                ${this.selection === 'accessibility' ? html`<intrivity-accessibility></intrivity-accessibility>`: html``}
                                ${this.selection === 'privacy' ? html`<intrivity-privacy></intrivity-privacy>`: html``}
                                ${(hasRole('trainer', this.user_profile) || hasRole('program_manager', this.user_profile)) && this.selection === 'training-docs' ? html`<intrivity-training-docs .user_profile=${this.user_profile}></intrivity-training-docs>`: html``}
                                ${hasRole('superadmin', this.user_profile) && this.selection === 'ai-models' ? html`<intrivity-ai-models-guide></intrivity-ai-models-guide>`: html``}
                                ${this.selection === 'message' ? html`
                                    <intrivity-domain-details domain_prefix="m" .domain=${this.message_domain} .group_reports=${this.group_reports} .group_report=${this.group_report} .report=${this.report}></intrivity-domain-details>
                                `: html``}
                                ${this.selection === 'space' ? html`
                                    <intrivity-domain-details domain_prefix="s" .domain=${this.space_domain} .group_reports=${this.group_reports} .group_report=${this.group_report} .report=${this.report}></intrivity-domain-details>
                                `: html``}                    
                                ${this.selection === 'time' ? html`
                                    <intrivity-domain-details domain_prefix="t" .domain=${this.time_domain} .group_reports=${this.group_reports} .group_report=${this.group_report} .report=${this.report}></intrivity-domain-details>
                                `: html``}  
                                ${this.selection === 'relationship' ? html`
                                    <intrivity-domain-details domain_prefix="r" .domain=${this.relationship_domain} .group_reports=${this.group_reports} .group_report=${this.group_report} .report=${this.report}></intrivity-domain-details>
                                `: html``}  
                                ${this.user_profile && this.selection === 'admin' ? html`
                                    <h1 class="sr-only">${t('nav.administration')}</h1>
                                    ${this.trainer_groups ? html`
                                        <intrivity-admin-groups mode="trainer" .user_profile=${this.user_profile} .groups=${this.trainer_groups}></intrivity-admin-groups>
                                    `: html``}
                                    ${this.pm_groups ? html`
                                        <intrivity-admin-groups mode="pm" .user_profile=${this.user_profile} .groups=${this.pm_groups}></intrivity-admin-groups>
                                    `: html``}
                                    ${hasRole('superadmin', this.user_profile) ? html`
                                        <intrivity-admin-clients .clients=${this.clients} .user_profile=${this.user_profile}></intrivity-admin-clients>
                                        <intrivity-admin-users2 .user_profile=${this.user_profile}></intrivity-admin-users2>
                                        <intrivity-admin-config .user_profile=${this.user_profile}></intrivity-admin-config>
                                        <intrivity-admin-training-docs .user_profile=${this.user_profile}></intrivity-admin-training-docs>
                                        <intrivity-admin-compliance .user_profile=${this.user_profile}></intrivity-admin-compliance>
                                        <intrivity-admin-audit-log .user_profile=${this.user_profile}></intrivity-admin-audit-log>
                                    `: html``}
                                `: html``}
                                ${this.masqueraded_user ? html`
                                    <mwc-button @click=${this.quit_masquerade}>${t('app.stopMasquerade')}</mwc-button>
                                `: html``}

                            </main>

                        </div>


                    `}
                `: html`
                    <intrivity-header .anon="true"></intrivity-header>
                    <main id="main-content" tabindex="-1" role="main" aria-busy="true">
                    <h3 role="status">${t('common.loading')}</h3>
                    ${this.space_domain ? html`<div>${t('app.domainLoaded', { domain: t('domain.space.name') })}</div>`: html``}
                    ${this.message_domain ? html`<div>${t('app.domainLoaded', { domain: t('domain.message.name') })}</div>`: html``}
                    ${this.relationship_domain ? html`<div>${t('app.domainLoaded', { domain: t('domain.relationship.name') })}</div>`: html``}
                    ${this.time_domain ? html`<div>${t('app.domainLoaded', { domain: t('domain.time.name') })}</div>`: html``}
                    </main>
                `}
            `}
        `
    }
     
}
if (!customElements.get('intrivity-app')) customElements.define('intrivity-app', IntrivityApp);


